<template>
  <div
    :class="[$style.vgp_label, $style.vgp_label_inline, $style.vgp_label_chip, $style[`vgp_label__${type}`], sizeClass]"
    :style="colorStyle"
  >
    <sprite
      v-if="type === 'icon'"
      :class="$style.vgp_label_icon"
      :name="iconName"
      :type="iconType"
      :size="16"
      :color="iconColor"
    />
    <span :class="$style.vgp_label_text">{{ value }}</span>
  </div>
</template>

<script>
import sprite from '$$uiKitComp/VueIcon/svgSprite.vue';

export default {
  name: 'VgpLabel',
  components: {
    sprite,
  },
  props: {
    value: {
      type: String,
      required: true,
      default: 'Text',
    },
    type: {
      type: String,
      default: 'text',
      validator: val => ['text', 'icon'].includes(val),
    },
    size: {
      type: String,
      default: 'extraExtraSmall',
      validator: val => ['large', 'small', 'extraSmall', 'extraExtraSmall'].includes(val),
    },
    icon: {
      type: Object, // { name, type, size, color }
      required: false,
      default: null,
    },
    bgColor: {
      type: String,
      required: false,
      default: null,
    },
    textColor: {
      type: String,
      required: false,
      default: '#FFFFFF',
    },
  },
  computed: {
    sizeClass() {
      if (this.type === 'icon') {
        return this.$style.vgp_label__size_icon;
      }

      return this.$style[`vgp_label__size_${this.size}`] || this.$style.vgp_label__size_extraExtraSmall;
    },
    getBgColor() {
      if (this.bgColor) {
        return this.bgColor;
      }

      return '#6447AE';
    },
    iconName() {
      return this.icon?.name || 'project';
    },
    iconType() {
      return this.icon?.type || 'regular';
    },
    iconColor() {
      return this.icon?.color || '#FFFFFF';
    },
    colorStyle() {
      return {
        '--vgp-label-bg': this.getBgColor,
        '--vgp-label-text': this.textColor,
      };
    },
  },
};
</script>

<style module lang="less" src="./less/label.less"></style>
